var _g, _rect, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRow26(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2335_35451)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    rx: 8,
    fill: "#161616"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    fill: "#161616"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_2335_35451)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17 17H43V43H17V17Z",
    fill: "#F0DB4F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.8724 36.7991C40.6821 35.6128 39.9085 34.6168 37.6174 33.6875C36.8216 33.3218 35.9344 33.0598 35.6699 32.4567C35.576 32.1058 35.5636 31.9081 35.623 31.6955C35.7935 31.006 36.6165 30.791 37.269 30.9887C37.6891 31.1296 38.087 31.4533 38.3268 31.9699C39.4488 31.2433 39.4463 31.2482 40.2298 30.749C39.9431 30.3041 39.7899 30.099 39.602 29.9087C38.9273 29.1549 38.0079 28.7668 36.5374 28.7965C36.2828 28.8286 36.0258 28.8632 35.7712 28.8954C35.0372 29.0807 34.3378 29.4663 33.9275 29.9828C32.6967 31.3792 33.0477 33.8235 34.5454 34.8294C36.0209 35.9366 38.1884 36.1887 38.4652 37.2243C38.7346 38.4921 37.5334 38.9024 36.3397 38.7566C35.4598 38.5737 34.9705 38.1264 34.4416 37.3132C33.4678 37.8767 33.4678 37.8767 32.4669 38.4526C32.7042 38.9716 32.9538 39.2064 33.3517 39.6562C35.235 41.5667 39.9481 41.4727 40.7933 38.5811C40.8279 38.4822 41.0553 37.8199 40.8724 36.7991ZM31.1347 28.9497H28.7028C28.7028 31.0505 28.6929 33.1364 28.6929 35.2372C28.6929 36.5742 28.7621 37.8001 28.5447 38.1758C28.1888 38.9147 27.2669 38.8233 26.8467 38.6799C26.4192 38.4698 26.2017 38.1708 25.9496 37.7482C25.8804 37.6271 25.8285 37.5332 25.8112 37.5258C25.1513 37.9286 24.4939 38.3339 23.834 38.7368C24.1627 39.4115 24.6471 39.9972 25.2674 40.3778C26.1943 40.9339 27.4399 41.1044 28.7424 40.8054C29.5901 40.5582 30.3216 40.0467 30.7047 39.2682C31.2583 38.2474 31.1397 37.0117 31.1347 35.645C31.1471 33.4157 31.1347 31.1864 31.1347 28.9497Z",
    fill: "#323330"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 59,
    height: 59,
    rx: 7.5,
    stroke: "white",
    strokeOpacity: 0.2
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2335_35451"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    rx: 8,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_2335_35451"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 26,
    fill: "white",
    transform: "translate(17 17)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRow26);
export default __webpack_public_path__ + "static/media/row-2-6.90f8e67b4f9ea01db96bda27aaa7cb7d.svg";
export { ForwardRef as ReactComponent };